import ManagementSidebar from "./ManagementSidebar.tsx";

export default function AdminPanelLayout({ children }) {
  return (
    <>
      <div className="d-flex flex-nowrap admin-container pt-5" style={{ backgroundColor: "#DBF0EE" }}>
        <div>
          <ManagementSidebar></ManagementSidebar>
        </div>
        <div className="w-100">{children}</div>
      </div>
    </>
  );
}
